<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Expenses",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Expense Item",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "desc",
          label: "Description",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        item: "",
        description: "",
        amount: "",
      },
      totals: {
        total: 0,
        paid: 0,
        date: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
        supplier: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        item: "",
        amount: "",
        description: "",
        id: "",
      },
      amountError: "",
      modeError: "",
      paidError: "",
      itemError: "",
      modal: "",
      existing: [],
    };
  },
  computed: {
    ...mapGetters("expenses", [
      "ExpenseCart",
      "ExpenseItems",
      "TotCart",
      "Suppliers",
      "SaveStatus",
    ]),
    ...mapGetters("modes", ["Modes"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.ExpenseCart ? this.ExpenseCart.length : 1;
    },
  },
  watch: {
    TotCart(newValue) {
      if (newValue) {
        this.assignTots();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ExpenseCart ? this.ExpenseCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSuppliers: "expenses/fetchSuppliers",
      FetchExpItems: "expenses/fetchExpenseItems",
      FetchExpCart: "expenses/fetchExpenseCart",
      FetchCartTotals: "expenses/fetchExpenseCartTot",
      FetchModes: "modes/fetchModes",
      AddToCart: "expenses/addToCart",
      EditCart: "expenses/editCart",
      DeleteCart: "expenses/deleteCart",
      Submit: "expenses/addExpense",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.ExpenseCart ? this.ExpenseCart.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    checkExist() {
      //when creating a new one
      if (this.data.item != "") {
        this.existing = this.ExpenseCart
          ? this.ExpenseCart.filter((cart) => {
              return cart.itemId == this.data.item;
            })
          : [];
        if (this.existing.length) {
          this.itemError = "This item exists in the cart already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existing = [];
      }
    },

    assignTots() {
      this.totals.total = this.thousandSeperater(this.TotCart);
      this.totals.paid = this.thousandSeperater(this.TotCart);
    },
    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },
    addCommasEdit() {
      this.editdata.amount = this.thousandSeperater(this.editdata.amount);
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
      this.paidError = "";
      this.itemError = "";
    },

    resetAddModal() {
      this.data.item = "";
      this.data.amount = "";
      this.data.description = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.item = "";
      this.editdata.amount = "";
      this.editdata.description = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },
    resetTotals() {
      this.totals.total = "";
      this.totals.paid = "";
    },

    addToCart(modal) {
      if (this.data.amount == "") {
        this.amountError = "Amount Spent can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.item == "") {
        this.itemError = "Expense Item field can't be empty'";
        return;
      } else {
        this.itemError = "";
      }
      if (this.existing.length > 0) {
        this.itemError = "This Expense Item already Exists please'";
        return;
      } else {
        this.itemError = "";
      }
      this.modal = modal;
      this.AddToCart(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.amount = values.item.amount;
      this.editdata.item = values.item.itemId;
      this.editdata.description = values.item.desc;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteCart(modal) {
      this.modal = modal;
      this.DeleteCart(this.deletedata);
      this.closeModal(modal);
    },
    editCart(modal) {
      if (this.editdata.amount == "") {
        this.amountError = "Amount Spent can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.editdata.item == "") {
        this.itemError = "Expense Item field can't be empty'";
        return;
      } else {
        this.itemError = "";
      }
      this.modal = modal;
      this.EditCart(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    SubmitExp() {
      if (this.totals.mode == "") {
        this.modeError = "Payment Method Field is required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.totals.paid == "") {
        this.paidError = "Amount Paid can't be empty'";
        return;
      } else {
        this.paidError = "";
      }
      this.Submit(this.totals);
      this.resetTotals();
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.assignTots();
    this.FetchExpItems();
    this.FetchExpCart();
    this.FetchCartTotals();
    this.FetchModes();
    this.FetchSuppliers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('add_expenses')
        )
      "
    >
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of Items In Cart</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-primary float-end btn-sm"
                >
                  <i class="fa fa-plus"></i> Add To Cart
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ExpenseCart ? ExpenseCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_expenses')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_expenses')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9"><h3>Process Expense</h3></div>
              <div class="col-md-3">
                <router-link to="/expenses/view" class="btn btn-success btn-sm"
                  >Expenses</router-link
                >
              </div>
            </div>
            <div class="form-group mb-3">
              <label>Total Amount</label>
              <div class="input-group">
                <input
                  type="text"
                  disabled
                  placeholder="Enter Amount"
                  class="form-control"
                  @input="resetError(), addCommas()"
                  v-model="totals.total"
                />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>Amount Paid <span class="required">*</span></label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter Amount"
                  class="form-control"
                  @input="resetError(), addCommas()"
                  v-model="totals.paid"
                />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>Expense Date <span class="required">*</span></label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  @input="resetError(), addCommas()"
                  v-model="totals.date"
                />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>Payment Mode <span class="required">*</span></label>
              <div class="input-group">
                <model-list-select
                  :list="Modes ? Modes : []"
                  v-model="totals.mode"
                  option-value="id"
                  option-text="name1"
                  class="mb-2"
                  @input="resetError()"
                  placeholder="Select Payment Method"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>Supplier</label>
              <div class="input-group">
                <model-list-select
                  :list="Suppliers ? Suppliers : []"
                  v-model="totals.supplier"
                  option-value="id"
                  option-text="name1"
                  class="mb-2"
                  placeholder="Select Supplier"
                >
                </model-list-select>
              </div>
            </div>
            <div
              align="right"
              v-if="
                getCurrentUser.permissions.find((item) =>
                  item.permission.includes('add_expenses')
                )
              "
            >
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="SubmitExp()"
              >
                <i class="fa fa-check"></i> Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_expenses')
          )
        "
      >
        <template #modal-title> Add Item To Cart </template>
        <div class="form-group mb-3">
          <label>Expense Item <span class="required">*</span></label>
          <div class="input-group">
            <model-list-select
              required
              :list="ExpenseItems ? ExpenseItems : []"
              v-model="data.item"
              option-value="id"
              option-text="name1"
              class="mb-2"
              @input="resetError(), checkExist()"
              placeholder="Select Expense Item"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="itemError">
            <em>{{ itemError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Amount<span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="data.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Description</label>
          <div class="input-group">
            <textarea
              class="form-control"
              cols="30"
              rows="3"
              placeholder="Brief Description"
              v-model="data.description"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="addToCart('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_expenses')
          )
        "
      >
        <template #modal-title>
          Edit Revenue of Amount {{ editdata.amount }}</template
        >
        <div class="form-group mb-3">
          <label>Expense Item <span class="required">*</span></label>
          <div class="input-group">
            <model-list-select
              required
              :list="ExpenseItems ? ExpenseItems : []"
              v-model="editdata.item"
              option-value="id"
              option-text="name1"
              class="mb-2"
              @input="resetError()"
              placeholder="Select Expense Item"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="itemError">
            <em>{{ itemError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Amount <span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommasEdit()"
              v-model="editdata.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Description</label>
          <div class="input-group">
            <textarea
              class="form-control"
              cols="30"
              rows="3"
              placeholder="Brief Description"
              v-model="editdata.description"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="editCart('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete fyear starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_expenses')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete {{ deletedata.name }} From Cart
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete {{ deletedata.name }} From Cart? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteCart('delete-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
